import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { overrides, DefaultButtonProps } from '@cld/button';
import { Icon } from '@cld/icon';
import { messages } from '../../../i18n';

const { Button } = overrides.mediaLibraryWidgetDemoOverrides;

export interface ExpandButtonProps extends Omit<DefaultButtonProps, 'children'> {
  isSectionExpanded: boolean;
}

export const ExpandButton: FC<ExpandButtonProps> = ({ isSectionExpanded, ...rest }) => (
  <Button size="sm" {...rest}>
    <Icon name="expand" />
    <FormattedMessage {...messages[isSectionExpanded ? 'codeSection.expandButton.collapse' : 'codeSection.expandButton.expand']} />
  </Button>
);
